import { QbItaParameterResult } from '@fwmovilidad/qb-home-ita-components-lib';
import { Gender, MaritalStatus, PersonTitle, PrivateLiabilityDeductible, PrivateLiabilityTariff } from './bff';

export type Quote = {
  isVertiClient?: boolean;
  policyholderData?: PolicyholderData;
  bankAccountOwnerData?: BankAccountOwnerData;
  partnerData?: PartnerData;
  insuranceData?: InsuranceData;
  previousInsuranceData?: PreviousInsuranceData;
  externalReferences?: string;
};

export type PolicyholderData = {
  gender?: QbItaParameterResult;
  title?: QbItaParameterResult;
  name?: string;
  surname?: string;
  maritalStatus?: QbItaParameterResult;
  birthdate?: string;
  publicSector?: boolean;
  contact?: ContactData;
  address?: AddressData;
  taxDeduction?: boolean;
  occupation?: QbItaParameterResult;
  iban?: string;
  debitAuthorization?: boolean;
};

export type BankAccountOwnerData = {
  gender?: QbItaParameterResult;
  title?: QbItaParameterResult;
  name?: string;
  surname?: string;
  maritalStatus?: QbItaParameterResult;
  isPerson?: boolean;
  otherPerson?: boolean;
  iban?: string;
  ibanRef?: string;
  debitAuthorization?: boolean;
  address?: AddressData;
  paymentMethod?: string;
};

export type PartnerData = {
  gender?: QbItaParameterResult;
  title?: QbItaParameterResult;
  name?: string;
  surname?: string;
  maritalStatus?: QbItaParameterResult;
};

export type InsuranceData = {
  insuranceType?: PrivateLiabilityTariff;
  insuranceBeginDate?: string;
  promotionCode?: string;
  deductible?: QbItaParameterResult;
  document?: string;
  contractNumber?: string;
  additionalData?: any;
};

export type PreviousInsuranceData = {
  previousInsurance?: boolean;
  insurer?: QbItaParameterResult;
  canceller?: QbItaParameterResult;
  claims?: QbItaParameterResult;
};

export type ContactData = {
  email: string;
  phone: string;
};

export type AddressData = {
  street: string;
  houseNumber: string;
  postCode: string;
  city: string;
};
